import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';

const more: RibbonButton = {
    key: 'more',
    title: () => strings.more,
    imageSrc: require('../svg/more.svg'),
    createDropDownCallback: () => null, // NO OP. Just need a placeholder here. Ribbon will do special handling for more button
};

export default more;
